import script from "./fieldRadiobutton.vue?vue&type=script&setup=true&lang=js"
export * from "./fieldRadiobutton.vue?vue&type=script&setup=true&lang=js"

import "./fieldRadiobutton.vue?vue&type=style&index=0&id=8c6b7e2a&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c6b7e2a"]])

export default __exports__